import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type ItemLocationWithEventAccountFragment = { __typename?: 'ItemLocation', id: string, name: string, type?: string | null, disabled_at?: string | null, delivery_address?: { __typename?: 'IdName', id: string, name: string } | null, event_account?: { __typename?: 'EventAccount', id: string, name?: string | null } | null, event?: { __typename?: 'EventReduced', id?: string | null, name?: string | null } | null };

export const ItemLocationWithEventAccountFragmentDoc = gql`
    fragment ItemLocationWithEventAccount on ItemLocation {
  id
  name
  type
  disabled_at
  delivery_address {
    id
    name
  }
  event_account {
    id
    name
  }
  event {
    id
    name
  }
}
    `;